export default __webpack_public_path__ + "static/media/virginiaMapBg.837ffcd5.png";